var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBoldDown = function SvgIconArrowBoldDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.586 3c.89 0 1.337 1.077.707 1.707L6.707 8.293a1 1 0 0 1-1.414 0L1.707 4.707C1.077 4.077 1.523 3 2.414 3z"
  })));
};
export { SvgIconArrowBoldDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTg1NzkgM0MxMC40NzY3IDMgMTAuOTIyOSA0LjA3NzE0IDEwLjI5MjkgNC43MDcxMUw2LjcwNzExIDguMjkyODlDNi4zMTY1OSA4LjY4MzQyIDUuNjgzNDIgOC42ODM0MiA1LjI5MjkgOC4yOTI4OUwxLjcwNzExIDQuNzA3MTFDMS4wNzcxNCA0LjA3NzE0IDEuNTIzMzEgMyAyLjQxNDIyIDNIOS41ODU3OVoiIC8+Cjwvc3ZnPgo=";